import { IoIosArrowDown } from "react-icons/io";
import styles from "./Accordion.module.scss";
import React, { useState } from "react";

interface Props {
  title: string;
  children: React.ReactNode;
  color?: string | "#000000";
  headerChildren?: React.ReactNode;
  isEmpty?: boolean;
}

function Accordion(props: Props) {
  const {
    title,
    children,
    color = "#000000",
    headerChildren,
    isEmpty = false,
  } = props;

  const [isOpen, setIsOpen] = useState(false);

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className={styles.mainContainer}>
      <div className={styles.headerContainer} onClick={toggleAccordion}>
        <h3 className={styles.heading} style={{ color: color }}>
          {title}
        </h3>
        {headerChildren}
        <IoIosArrowDown
          className={`${styles.icon} ${isOpen ? styles.iconActive : ""}`}
          size={20}
          color="#000000"
          onClick={toggleAccordion}
        />
      </div>
      <div
        className={`${styles.contentContainer} ${isOpen ? styles.contentContainerActive : ""}`}
      >
        {children}
        {isEmpty && (
          <div className={styles.isEmptyContainer}>
            <p className={styles.emptyText}>No data available</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default Accordion;
